import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "./TourDetails.css";

function TourDetails() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://mdt.24x7it.in/api/tour-detail/${id}`)
      .then(res => res.json())
      .then(res => {
        setData(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="loading">Loading tour...</div>;
  if (!data) return <div className="loading">Tour not found</div>;

  const { tour, gallery, related_tours } = data;

  return (
    <>
      <Helmet>
        <title>{tour.meta_title || tour.title}</title>
        <meta
          name="description"
          content={tour.meta_description || tour.short_desc}
        />
      </Helmet>

      <div className="tour-details">

        {/* HERO */}
        <div className="hero">
          <img src={tour.header_image} alt={tour.title} />
          <div className="hero-overlay">
            <h1>{tour.title}</h1>
            <p>{tour.zone_name}</p>
          </div>
        </div>

        <div className="container">

          {/* PRICE SECTION */}
          <div className="price-box">
            <div>
              <h3>${tour.adult_price}</h3>
              <span>Adult</span>
            </div>
            <div>
              <h3>${tour.child_price}</h3>
              <span>Child</span>
            </div>
            <button className="book-btn">Book Now</button>
          </div>

          {/* DESCRIPTION */}
          <div className="section">
            <h2>About This Tour</h2>
            <div
              dangerouslySetInnerHTML={{ __html: tour.description }}
            />
          </div>

          {/* GALLERY */}
          {gallery.length > 0 && (
            <div className="section">
              <h2>Gallery</h2>
              <div className="gallery">
                {gallery.map(img => (
                  <img
                    key={img.id}
                    src={img.large_pic}
                    alt={img.title}
                  />
                ))}
              </div>
            </div>
          )}

          {/* INCLUDE */}
          {tour.include && (
            <div className="section">
              <h2>What To Bring</h2>
              <ul>
                {tour.include.map((item, i) => (
                  <li key={i}>{item.trim()}</li>
                ))}
              </ul>
            </div>
          )}

          {/* ADDITIONAL INFO */}
          {tour.additional_info && (
            <div className="section">
              <h2>Additional Information</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: tour.additional_info
                }}
              />
            </div>
          )}


        </div>
      </div>
    </>
  );
}

export default TourDetails;